// extracted by mini-css-extract-plugin
module.exports = {"balance":"FormTokens-module--balance--31bFx","input":"FormTokens-module--input--1IarN"};